import React from "react";
import { BatteryFull, Battery50, Battery20 } from "@material-ui/icons";
import styled from "styled-components";

const BatteryContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const BatteryIconWrapper = styled.div`
  margin-right: 10px;
  color: ${(props) => props.background};
  transform: rotate(90deg);
`;

const BatteryText = styled.div`
  margin-left: 5px;
`;

export const BatterySymbol = ({ battery }) => {
  const width = battery / 5;
  const background =
    battery > 66 ? "#00864F" : battery > 15 ? "#FF9500" : "#D70015";

  const getBatteryIcon = () => {
    if (battery > 66) {
      return <BatteryFull />;
    } else if (battery > 15) {
      return <Battery50 />;
    } else {
      return <Battery20 />;
    }
  };

  return (
    <BatteryContainer>
      <BatteryIconWrapper background={background}>
        {getBatteryIcon()}
      </BatteryIconWrapper>
      <BatteryText>{battery}%</BatteryText>
    </BatteryContainer>
  );
};
